// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CreatingForm_wrapper__2Fh9R","add":"CreatingForm_add__c3886","popup":"CreatingForm_popup__39iyB","label":"CreatingForm_label__1A6T4","btn":"CreatingForm_btn__2vzge"};